/**
 * CarouselNav - external prev/next navigation buttons paired with a slider instance.
 * Custom element: <carousel-nav>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class CarouselNav extends ThemeComponent {}
setFunctionName(CarouselNav, "CarouselNav");
const propertyTypes = {};
CarouselNav.prototype.$name = "CarouselNav";
CarouselNav.prototype.$info = JSON.parse('{"name":"CarouselNav","meta":{"isLegacy":false,"selector":"carousel-nav"},"props":[],"refs":[]}');
CarouselNav.prototype.$info.component = CarouselNav;
for (const prop of CarouselNav.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Carousel/CarouselNav.ts", {
  CarouselNav: CarouselNav
}, void 0);